<template>
  <section class="choose-theme-sec">
    <div class="container">
    	<div class="import-text-wrap">
    		<div class="text-area">
    			<textarea v-model="importText" placeholder="Click here to type or paste your post. Imported text will be added the back of whatever you’ve written already."></textarea>
    			<p>{{importText.length}} words</p>
    		</div>
    		<ul class="import-btn">
    			<li>
    				<button type="reset" @click="$router.go(-1)" class="navitem">CANCEL</button>
    				<button type="button" class="navitem importBg">IMPORT</button>
    			</li>
    		</ul>
    	</div>
    </div>

  </section>
</template>

<script>
export default {

	data() {
		return {
			importText:'',
		}
	},

	methods: {
		reset(){
			this.importText='';
		},
	},


}

</script>



<style>
	@import '../assets/css/import-text.css';
</style>


